<template>
  <div class="search-settings">

    <div v-show="group1.isSearchDetail" 
      class="button">
      <button class="btn" type="button" name="button"
        @click="openSearchDetail"
      >
        <FontawesomeIcon :icon="['fas','search']" class="icn"/>
        詳細検索の条件を変更する
      </button>
    </div>
    <!-- 詳細検索の場合は、簡易検索用の表記ゆれ・同意語を含むチェックボックスは不要 -->
    <!-- 【注意】
      次のv-show="!group1.isSearchDetail"に対して、v-ifを表示すると、
      onMountedにてref="searchButton"に対して設定したイベントリスナーが外れてしまう問題があるため、
      使用しないこと。
    -->
    <form v-show="!group1.isSearchDetail" 
      @submit.prevent="blurAndSearch" :class="group1.gaSearchClass">
      <div class="formparts select"
        v-click-outside="() => { searchSelect.isFocusInput = false }"
        :class="{ 'is-visible-list': searchSelect.isFocusInput }"
      >
        <div @click="searchSelect.isFocusInput = !searchSelect.isFocusInput"
          class="select-label" role="select">{{ group1.searchCategoryName }}<FontawesomeIcon :icon="searchSelect.isFocusInput ? 'angle-up' : 'angle-down'" class="icn" /></div>
        <div class="select-option">
          <ul class="select-option-list short1">
            <li role="option">
              <label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="qa">Q&amp;A・事例</label>
              </li>
            <li role="option">
              <label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="knowledge">最新ナレッジ</label>
            </li>
            <li role="option">
              <label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="book">書籍目次</label>
            </li>
            <li role="option">
              <label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="note">ノート</label>
            </li>
          </ul>
        </div>
      </div>
      <div class="formparts function mb8">
        <input type="text"
          v-model="group1.search_text_input"
          maxlength="50"
          placeholder="キーワードを入力（最大50文字）" ref="focusInput">
        <div class="button ga-search-qa" role="button" ref="searchButton"
        ><FontawesomeIcon icon="search" class="icn" /></div>
      </div>
      <div class="column gutter">
        <div class="column-item col-6 space-gutter">
          <div class="formparts checkbox mt12 ml12"
            v-if="group1.searchCategory !== 'download' && group1.searchCategory !== 'note'" 
          >
            <input type="checkbox" id="qa_list_is_fuzzy"
              v-model.number="group1.is_fuzzy_input" 
              :true-value="0"
              :false-value="1"
            >
            <label for="qa_list_is_fuzzy">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
        </div>
        <div class="column-item col-6 space-gutter">
          <span @click="group1.searchResetOptions" class="search-settings-clear">検索をクリア</span>
        </div>
        <div v-if="group1.searchCategory === 'qa'" class="column-item col-6 space-gutter">
          <div class="button">
            <button class="btn" type="button" name="button"
              @click="openSearchDetail"
            >詳細検索</button>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'

import * as logicSearchUI from '@/logic/common/SearchUI'

export default defineComponent({
  name: 'SPSearchUI',
  directives: {
    ClickOutside
  },
  props: {
    // 呼び出している画面の種類
    // (dashboard:ダッシュボード、menu: メニュー、
    // qa:QA一覧、book:書籍一覧、download:書式DL一覧、
    // knowledge:最新ナレッジ一覧、note:ノート一覧)
    screenType: {
      type: String,
      default: '',
      required: true
    },
    // 同画面でキーワード検索が実行されたか？
    // (1)キーワード入力欄でEnterを押した
    // (2)キーワード入力欄の検索ボタンを押した場合
    // ※他の画面から遷移してきた場合はfalse
    isSearchExecutedAtSameScreen: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    const { group1, suggest, searchSelect } = logicSearchUI.getGroup(props, context)

    const openSearchDetail = () => {
      context.emit('openSearchDetail')
    }

    // ソフトウェアキーボードを閉じてから検索
    const blurAndSearch = () => {
      context.refs.focusInput.blur()
      group1.search()
    }

    onMounted(() => {
      // キーワード入力欄がソフトウェアキーボードの裏に隠れないように画面上部に移動させる
      context.refs.focusInput.addEventListener('focus', (event) => {
        context.emit('handleFocusInput')
      })
      context.refs.searchButton.addEventListener('mousedown', (event) => {
        // 検索実行
        blurAndSearch()
      })
      context.refs.focusInput.addEventListener('blur', (event) => {
        context.emit('handleFocusOutInput')
      })
    })

    return {
      group1,
      suggest,
      searchSelect,
      openSearchDetail,
      blurAndSearch
    }
  }
})
</script>

<style lang="scss" scoped>

.search-settings {
  position: fixed;
  z-index: $index-menu;
  // height: 205px;
  height: 270px;
  transform: translate3d(0,100%,0);
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px 0 0 0;
  transition: transform .2s ease;
  .button .icn {
    margin-right: 10px;
  }
  .formparts.checkbox {
    margin-top: 20px;
    display: inline-block;
  }
  .is-focused-input & {
    transform: translate3d(0,-200%,0) !important;
    box-shadow: none !important;
    .select-label {
      visibility: hidden;
    }
    .formparts.function {
      margin: 20px 20px 0!important;
    }
    .column {
      display: none;
    }
  }
  .search-settings-clear {
    display: table;
    position: relative;
    top: 11px;
    margin-left: auto;
    color: $color-link;
  }
}
</style>
